module.exports = __webpack_public_path__ + "images/health.c4ea1e53cfa8bc7b7e263129f2acece7.svg";